
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
     // WISHLIST
   if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
     Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
   }
   Flits(document).on('Flits:wishlistButton:Loaded', function(event){
     if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product'|| Flits.request.page_type == 'cart') {
       let collectionBtn = Flits('.flits-wishlist-colection');
       parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
         Flits(collectionBtn).show(),
         Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
     }
   });
  
  Flits(document).ready(function(){
    // if(Flits.request.page_type === 'cart'){
      setInterval(function(){
        document.querySelectorAll(".line-item__content-wrapper .flits-wishlist-colection .flits-wls-button ").forEach(el => {
          let product_attr = el.getAttribute('data-flits-product-handle');
          let isProduct = Flits.isProductAddedInWishlist(product_attr);
          if(isProduct){
            el.classList.remove("flits-wls-inactive");
            el.classList.add("flits-wls-active");
            Flits(el).attr('data-tippy-content', Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
            Flits(el).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
          }
        });
      },2000);
    // }
  });
}(Flits));
